import type { KycVerificationSiteSettings } from '../../kycVerification.types.ts';

const KYC_VERIFICATION: KycVerificationSiteSettings = {
  methods: [
    {
      name: 'greenid-fallback',
      stepId: 'greenid',
      icon: 'Verification',
      translationKey: 'greenid',
      dataTrackName: 'GreenID',
    },
    {
      name: 'manual-upload',
      stepId: 'manual-upload',
      icon: 'Passport',
      translationKey: 'manual_upload',
      dataTrackName: 'Passport And Utility Bill',
    },
  ],
};

export { KYC_VERIFICATION };
